module.exports = __webpack_public_path__ + "img/ballantines-form-bg.a81030ac.png";